import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    name: 'home',
    path: '/',
    component: () => import('../pages/home/HomePage.vue'),
  },
  {
    name: 'booking',
    path: '/booking/:tripId',
    component: () => import('../pages/booking/BookingPage.vue'),
  },
  {
    name: 'trip',
    path: '/trip/:tripId',
    component: () => import('../pages/trip/TripPage.vue'),
  },
  {
    name: 'booked',
    path: '/booked',
    component: () => import('../pages/booked/BookedPage.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'home' },
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }

    if (to.name === 'trip' || to.name === 'booking') {
      return { top: 0 }
    }

    return { top: 0 }
  },
})

export default router
